// NOTE: reference: https://stackoverflow.com/a/46181/14923262

export const isValidEmail = (inputUrl: string): boolean => {
  let pattern = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
  return !!pattern.test(inputUrl)
}
